import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-markdown.tsx
var LazyMarkdown = lazy(() => import("./markdown-CUXdtkno.js").then((n) => n.n).then((module) => ({ default: module.Markdown })));
function Markdown({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "markdown" }),
		children: /* @__PURE__ */ jsx(LazyMarkdown, { ...props })
	});
}
function MarkdownContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "markdown" }),
		children: /* @__PURE__ */ jsx(LazyMarkdown, { ...props })
	});
}
var useMarkdownContent = () => {
	return useMemo(() => ({ markdown: { component: MarkdownContent } }), []);
};
//#endregion
export { Markdown, useMarkdownContent };
